// reservationStatusTexts.tsx
import React from "react";
import styled from "styled-components";

/* ---------- Drop-in bold that always shows bolder ---------- */
import i18n from "../i18n";
export const Strong = styled.span`
  font-weight: bold !important; /* force heavy */
  font-variation-settings: "wght" 900; /* for variable fonts */
  font-synthesis-weight: none; /* avoid fake bold */
`;

/* ---------- Status groups (unchanged) ---------- */
export const cancelledStatuses = ["cancelled_customer", "cancelled_restaurant", "Cancelled"];
export const cancelledDidNotAttendStatuses = ["cancelled_customer", "cancelled_restaurant", "Cancelled", "no_show"];
export const acceptedStatuses = ["accepted", "late", "waiting_list"];
export const pendingStatuses = ["pending_customer", "pending_restaurant"];

/* ---------- Abbreviation (unchanged) ---------- */
export function getReservationStatusAbreviationTranslation(status) {
  switch (status) {
    case "past_estimated_time":
      return <>{i18n.t("ui.components.reservationStatus.libertarMesa")}</>;
    case "accepted":
    case "Accepted_Without_Table":
    case "Accepted_With_Table":
      return <>{i18n.t("ui.components.reservationStatus.confirmada")}</>;
    case "pending_customer":
      return <>{i18n.t("ui.components.reservationStatus.aguardaReconfirmacaoDoCliente")}</>;
    case "pending_restaurant":
      return <>{i18n.t("ui.components.reservationStatus.aguardaAceitacaoDoRestaurante")}</>;
    case "waiting_list_by_client":
    case "queue":
    case "in_front":
      return <>{i18n.t("ui.components.reservationStatus.naListaDeEspera")}</>;
    case "waiting_list":
      return <>{i18n.t("ui.components.reservationStatus.naFilaAPorta")}</>;
    case "edited":
      return <>{i18n.t("ui.components.reservationStatus.alteracaoPorAceitar")}</>;
    case "Accepted_edit":
      return <>{i18n.t("ui.components.reservationStatus.alteracaoAceite")}</>;
    case "Rejected_edition":
      return <>{i18n.t("ui.components.reservationStatus.alteracaoRecusada")}</>;
    case "late":
      return <>{i18n.t("ui.components.reservationStatus.atrasada")}</>;
    case "attended":
      return <>{i18n.t("ui.components.reservationStatus.mesaOcupada")}</>;
    case "completed":
      return <>{i18n.t("ui.components.reservationStatus.mesaLivre")}</>;
    case "no_show":
      return <>{i18n.t("ui.components.reservationStatus.naoCompareceu")}</>;
    case "cancelled_customer":
    case "Cancelled":
      return <>{i18n.t("ui.components.reservationStatus.canceladaCliente")}</>;
    case "cancelled_restaurant":
    case "Rejected":
      return <>{i18n.t("ui.components.reservationStatus.canceladaRestaurante")}</>;
    default:
      return <>{i18n.t("ui.components.reservationStatus.null")}</>;
  }
}

/* ---------- Tooltip (restaurant) with <Strong> ---------- */
export function getReservationStatusTooltipTranslationForRestaurant(status) {
  switch (status) {
    case "past_estimated_time":
      return <>{i18n.t("ui.components.reservationStatus.libertarMesa2")}</>;
    case "accepted":
    case "Accepted_Without_Table":
    case "Accepted_With_Table":
      return <>
          <Strong>{i18n.t("ui.components.reservationStatus.reservaConfirmada")}</Strong>
          <br />
          <br />{i18n.t("ui.components.reservationStatus.aguardarChegadaDosClientes")}</>;
    case "pending_restaurant":
      return <>{i18n.t("ui.components.reservationStatus.oRestauranteDeveAceitarOuRecusar")}</>;
    case "waiting_list_by_client":
    case "queue":
    case "in_front":
      return <></>;
    case "edited":
      return <>{i18n.t("ui.components.reservationStatus.oRestauranteDeveAceitarOuRecusar2")}</>;
    case "Edited_accept":
      return <>{i18n.t("ui.components.reservationStatus.oRestauranteDeveAceitarOuRecusar3")}<br />
          <br />
          <Strong>{i18n.t("ui.components.reservationStatus.atencao")}</Strong>{i18n.t("ui.components.reservationStatus.aEdicaoSeraAceiteEA")}<Strong>{i18n.t("ui.components.reservationStatus.confirmada2")}</Strong>{i18n.t("ui.components.reservationStatus.ouAAguardarReconfirmacaoDoCliente")}<br />
        </>;
    case "Edited_reject":
      return <>{i18n.t("ui.components.reservationStatus.oRestauranteDeveAceitarOuRecusar4")}<br />
          <Strong>{i18n.t("ui.components.reservationStatus.atencao2")}</Strong>{i18n.t("ui.components.reservationStatus.aEdicaoSeraAceiteEA2")}<Strong>{i18n.t("ui.components.reservationStatus.confirmada3")}</Strong>{i18n.t("ui.components.reservationStatus.ouAAguardarReconfirmacaoDoCliente2")}<br />
        </>;
    case "Accepted_edit":
      return <>
          <Strong>{i18n.t("ui.components.reservationStatus.atencao3")}</Strong>{i18n.t("ui.components.reservationStatus.aEdicaoSeraAceiteEA3")}<Strong>{i18n.t("ui.components.reservationStatus.confirmada4")}</Strong>{i18n.t("ui.components.reservationStatus.ouAAguardarReconfirmacaoDoCliente3")}<br />{i18n.t("ui.components.reservationStatus.seAReservaEstava")}{" "}
          <Strong>{i18n.t("ui.components.reservationStatus.aAguardarAceitacaoDoRestaurante")}</Strong>{i18n.t("ui.components.reservationStatus.ficaraDefinitivamente")}<Strong>{i18n.t("ui.components.reservationStatus.recusada")}</Strong>.
          <br />{i18n.t("ui.components.reservationStatus.seAReservaEstava2")}{" "}
          <Strong>{i18n.t("ui.components.reservationStatus.confirmadaOuAAguardarReconfirmacaoDo")}</Strong>{i18n.t("ui.components.reservationStatus.continuaraNoEstadoEmQueEstava")}</>;
    case "Rejected_edition":
      return <>{i18n.t("ui.components.reservationStatus.notaDescritivaDoEstadoRespetivo")}</>;
    case "late":
      return <>{i18n.t("ui.components.reservationStatus.jaPassaDaHoraMarcada")}</>;
    case "waiting_list":
      return <>{i18n.t("ui.components.reservationStatus.naFilaAPorta2")}</>;
    case "cancelled_customer":
    case "Cancelled":
      return <>{i18n.t("ui.components.reservationStatus.reservaCanceladaPor")}<Strong>{i18n.t("ui.components.reservationStatus.cliente")}</Strong>
          <br />
        </>;
    case "cancelled_restaurant":
      return <>{i18n.t("ui.components.reservationStatus.reservaRecusadaPeloRestaurante")}</>;
    case "attended":
      return <>{i18n.t("ui.components.reservationStatus.refeicaoEmCurso")}</>;
    case "completed":
      return <>{i18n.t("ui.components.reservationStatus.refeicaoConcluida")}</>;
    case "no_show":
      return <>{i18n.t("ui.components.reservationStatus.aReservaNaoSeConcretizou")}</>;
    default:
      return <></>;
  }
}
export function getReservationStatusTranslationClient(status) {
  switch (status) {
    // ✅ Reserva confirmada
    case "accepted":
    case "Accepted_Without_Table":
    case "Accepted_With_Table":
      return <>{i18n.t("ui.components.reservationStatus.reservaConfirmada2")}</>;

    // 🟡 Pendente do restaurante
    case "pending_restaurant":
      return <>{i18n.t("ui.components.reservationStatus.reservaPendenteDeConfirmacaoDoRestaurante")}</>;

    // 🟡 Alteração pendente
    case "edited":
      return <>{i18n.t("ui.components.reservationStatus.pedidoDeAlteracaoPendenteDeConfirmacao")}</>;

    // 🟢 Alteração aceite
    case "Accepted_edit":

    // 🔴 Alteração recusada
    case "Rejected_edition":

    // 🟠 Atraso
    case "late":
      return <>{i18n.t("ui.components.reservationStatus.estasAtrasadoA")}</>;

    // 🟡 Fila / lista de espera
    case "waiting_list":
    case "waiting_list_by_client":
    case "queue":
    case "in_front":
      return <>{i18n.t("ui.components.reservationStatus.avisamosQuandoTivermosMesaDisponivel")}</>;

    // 🟢 Mesa pronta
    case "table_ready":
      return <>{i18n.t("ui.components.reservationStatus.aTuaMesaEstaPronta")}</>;

    // 🟢 Estado genérico (se usares isto noutros sítios)
    case "attended":
      return <>{i18n.t("ui.components.reservationStatus.reservaConfirmada3")}</>;

    // 🟢 Finalizada
    case "completed":
      return <>{i18n.t("ui.components.reservationStatus.reservaConfirmada4")}</>;

    // ❌ No-show
    case "no_show":
      return <>{i18n.t("ui.components.reservationStatus.faltaDeComparencia")}</>;

    // 🔴 Cancelada pelo cliente
    case "cancelled_customer":
    case "Cancelled":
      return <>{i18n.t("ui.components.reservationStatus.cancelasteATuaReserva")}</>;

    // 🔴 Cancelada/recusada pelo restaurante
    case "cancelled_restaurant":
    case "Rejected":
      return <>{i18n.t("ui.components.reservationStatus.aTuaReservaFoiCanceladaPelo")}</>;
    default:
      return <>{i18n.t("ui.components.reservationStatus.estadoDesconhecido")}</>;
  }
}

/* ---------- Colors (unchanged) ---------- */
export function getReservationStatusColors(status) {
  switch (status) {
    case "pending_customer":
    case "pending_restaurant":
    case "edited":
    case "late":
    case "waiting_list":
    case "accepted":
    case "attended":
      return "#4CAE4C";
    case "no_show":
    case "cancelled_customer":
    case "Cancelled":
    case "cancelled_restaurant":
      return "#D94B4B";
    default:
      return "Null";
  }
}
